import { useQuery } from '@tanstack/react-query'
import { apiClient } from '@/shared/api/apiClient'

export const OPEN_ROHS_PARTS_QUERY_KEY = 'openRohsParts' as const

export type OpenRohsPartView = {
  componentId: string
  sku: string
  componentName: string | null
  supplierName: string
  complianceActor: 'OEM' | 'SUPPLIER'
  missingComplete: boolean
  missingFiles: boolean
}

export type OpenRohsPartsState = {
  parts: OpenRohsPartView[]
}

export function useGetOpenRohsParts(
  productId: string | undefined,
  options?: { enabled?: boolean }
) {
  return useQuery<OpenRohsPartsState, Error>({
    queryKey: [OPEN_ROHS_PARTS_QUERY_KEY, productId],
    queryFn: async () => {
      const response = await apiClient.get<OpenRohsPartsState>(
        `/v2/products/${productId}/open-rohs-parts`
      )
      return response.data
    },
    enabled:
      (options?.enabled ?? true) && productId != null && productId.length > 0,
  })
}
